import React from 'react'
import ModalWrapper from './ModalWrapper'
import BulkAddStudentsContainer from '../../containers/sections/BulkAddStudentsContainer'

const BulkAddStudentsModal= props => {
	return (
		<div className="bulkStudents-modal">
			<ModalWrapper
				{...props}
				title={`Add Students to ${props.section.name}`}
				modalStyle="dark"        
			>

				<BulkAddStudentsContainer {...props} />

			</ModalWrapper>

		</div>

	)
}

export default BulkAddStudentsModal


// WEBPACK FOOTER //
// ./src/components/modals/BulkAddStudentsModal.js